import { useUpdateRecord } from "../../api/useUpdateRecord";
import { Checkbox, CircularProgress } from "@mui/material";
import { useState } from "react";

type TaskGridDoneProps = {
    id: number;
    status: string;
    onStatusChange?: () => void;
};

export const TaskDoneShortcut = ({ id, status, onStatusChange }: TaskGridDoneProps) => {
    const [checked, setChecked] = useState(status === "done" ? true : false);
    const mutation = useUpdateRecord();

    const handleChange = async (newChecked: boolean) => {
        await mutation.mutateAsync({
            entity: "tasks",
            id: id,
            data: {
                status: newChecked ? "done" : "open",
            },
        });
        setChecked(newChecked);

        if (onStatusChange) {
            onStatusChange();
        }
    };

    if (mutation.isLoading) {
        return <CircularProgress size={24} sx={{ m: "9px" }} />;
    }

    return (
        <Checkbox
            checked={checked}
            onClick={(e) => {
                e.stopPropagation();
            }}
            onChange={(e) => {
                handleChange(e.target.checked);
            }}
        />
    );
};
